export const TEMPORARY_ACCOUNT_NUMBER_LENGTH = 36;
export const GIFTCARD_ITEMID = '99991';
export const MIN_AGE_FOR_SIGNUP = 18;
export const AUTOCOMPLETE_PREVENTION_PREFIX = 'venchi-no-autofill';
